import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { User } from '@models/user.model';

@Component({
    selector: 'app-strain-process-owners-tags',
    templateUrl: './strain-process-owners-tags.component.html',
    styleUrls: ['./strain-process-owners-tags.component.scss']
})
export class StrainProcessOwnersTagsComponent {
    @Input() owners: User[] = [];
    @Input() users: User[] = [];
    @Input() label = '';
    @Input() emptyText = '';
    @Input() placeholder = '';
    @Input() isEditable = false;

    @Output() ownersChange = new EventEmitter<User[]>();

    ownerControl = new UntypedFormControl(null);

    onOwnerSelected(owner: User) {
        if (!owner) {
            return;
        }

        if (this.isOwnerSelected(owner)) {
            this.clearSelection();
            return;
        }

        const nextOwners = [...(this.owners || []), owner];
        this.ownersChange.emit(nextOwners);
        this.clearSelection();
    }

    removeOwner(owner: User) {
        if (!owner) {
            return;
        }

        const nextOwners = (this.owners || []).filter(item => item?.id !== owner.id);
        this.ownersChange.emit(nextOwners);
    }

    displayName(owner: User) {
        return owner?.name || owner?.fullName || '-';
    }

    private isOwnerSelected(owner: User) {
        return !!(this.owners || []).find(item => item?.id === owner.id);
    }

    private clearSelection() {
        this.ownerControl.reset();
    }
}
